<template>
  <div class="flex flex-col">
    <div class="flex flex-col space-y-2 py-2" v-if="previews.length > 0">
      <div
        class="flex justify-between space-x-2 items-center bg-white border border-gray-200 rounded-md px-2 py-1"
        v-for="preview in previews"
        :key="preview.id"
      >
        <MediaPreview class="h-full" :item="preview" size="xs" />
        <div class="flex w-full flex-col text-sm overflow-hidden pr-12">
          <span class="truncate text-ellipsis">{{ preview.name }}</span>
          <span class="text-gray-500">{{ formatBytes(preview.size) }}</span>
        </div>
        <div>
          <XMarkIcon
            class="h-6 w-6 cursor-pointer text-gray-400 hover:text-gray-500"
            aria-hidden="true"
            @click="handleRemoveMedia(preview.id)"
          />
        </div>
      </div>
    </div>

    <FileInput
      accept="image/png, image/jpg, image/jpeg, video/mp4, video/quicktime, video/ogg, video/webm"
      ref="mediaInput"
      @input="handleMediaSelected"
      hidden
      multiple
      :disabled="disabled"
    />
    <Errors class="mb-2" :errors="mediaInput?.errors" />
    <div>
      <button
        :disabled="disabled"
        class="rounded-md border border-gray-300 bg-white px-2.5 py-2 text-base font-medium text-gray-700 shadow-sm sm:w-auto sm:text-sm disabled:opacity-50"
        :class="{
          '!cursor-not-allowed': disabled,
          'hover:text-gray-500 focus:outline-none': !disabled,
        }"
        @click="handleOpenMediaSelector"
      >
        {{ t("components.buttons.upload") }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { uniqueId } from "lodash";
import { formatBytes } from "@/Tailwind/Helpers/size";
import { XMarkIcon } from "@heroicons/vue/20/solid";
import MediaPreview from "@/Tailwind/Components/MediaPreview.vue";
import Errors from "@/Tailwind/Components/Errors.vue";
import { FileInput } from "@/Components/Inputs";

const props = defineProps({
  disabled: Boolean,
  value: Array,
});

const emit = defineEmits(["files"]);

const { t } = useI18n();

const mediaInput = ref();
const media = ref(props.value ?? []);

const previews = computed(() => {
  return media.value.map((item) => ({
    id: item.id,
    type: item.file.type,
    name: item.file.name,
    size: item.file.size,
    data: item.file,
  }));
});

const handleOpenMediaSelector = () => mediaInput.value.click();

const handleRemoveMedia = (id) => {
  media.value = media.value.filter((item) => item.id !== id);

  emit("files", media.value);
};

const handleMediaSelected = (files) => {
  media.value.push(
    ...files.map((file) => ({
      id: uniqueId(),
      file,
    }))
  );

  emit("files", media.value);
};
</script>
